var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { overflow: "hidden" } },
    [
      _c(
        "div",
        { staticClass: "allPage", attrs: { id: "survivalDetail" } },
        [
          _c(
            "van-pull-refresh",
            {
              staticClass: "refresh-box pullStyle",
              attrs: {
                id: "refresh-box",
                "success-text": "刷新成功",
                "head-height": 54
              },
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.isLoading,
                callback: function($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading"
              }
            },
            [
              _c(
                "div",
                { staticClass: "primaryPage", attrs: { id: "allPage" } },
                [
                  _c("div", { staticClass: "fundDetail" }, [
                    _c("div", { staticClass: "fund-name" }, [
                      _c("div", { staticClass: "fundN" }, [
                        _vm._v(_vm._s(_vm.dataObj.fundName))
                      ]),
                      _c("div", { staticClass: "fundLabel" }, [
                        _c("div", { staticClass: "fundC" }, [
                          _vm._v(_vm._s(_vm.dataObj.fundCode))
                        ]),
                        !!_vm.riskLevel
                          ? _c("div", { staticClass: "risk" }, [
                              _vm.showRiskImg === true
                                ? _c("img", {
                                    staticClass: "risk_img",
                                    attrs: {
                                      src: require("@/assets/images/header/riskBg.png")
                                    }
                                  })
                                : _vm._e(),
                              _c("span", { staticClass: "risk_txt" }, [
                                _vm._v(" " + _vm._s(_vm.riskLevel) + " ")
                              ])
                            ])
                          : _vm._e(),
                        !!_vm.fundType
                          ? _c("div", { staticClass: "risk" }, [
                              _c("span", { staticClass: "risk_txt" }, [
                                _vm._v(" " + _vm._s(_vm.fundType) + " ")
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]),
                    !_vm.isMonetaryFund
                      ? _c("div", { staticClass: "investmentT" }, [
                          _c(
                            "div",
                            {
                              staticClass: "investmentT__des",
                              on: { click: _vm.entryInvestment }
                            },
                            [_vm._v("投资检视")]
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "allSurvival" },
                      [
                        _c("span", { staticClass: "allSurvival__span" }, [
                          _vm._v("持有金额 (元)")
                        ]),
                        _c("van-icon", {
                          attrs: { name: "question-o" },
                          on: { click: _vm.toastInfo }
                        })
                      ],
                      1
                    ),
                    _vm.dataObj.lockTitle
                      ? _c("div", { staticClass: "allSurvival" }, [
                          _c("span", { staticClass: "allSurvival__tag" }, [
                            _vm._v(_vm._s(_vm.dataObj.lockTitle))
                          ])
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "mineSurvival" },
                      [
                        _vm.getValueStatus(_vm.positionAmount) == "4"
                          ? [
                              _c(
                                "div",
                                { staticClass: "mineSurvival__Num normal" },
                                [_vm._v("--")]
                              )
                            ]
                          : [
                              _c("div", { staticClass: "mineSurvival__Num" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.positionAmount)
                                    ) +
                                    " "
                                )
                              ])
                            ]
                      ],
                      2
                    ),
                    _vm.dataObj.lockInShare
                      ? _c(
                          "div",
                          {
                            staticClass: "lockingShare",
                            on: { click: _vm.toShareDetail }
                          },
                          [
                            _c("span", { staticClass: "lockingShare__span" }, [
                              _vm._v("锁定份额 "),
                              _c(
                                "span",
                                { staticClass: "lockingShare__count" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.dataObj.lockInShare
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" 份")
                            ])
                          ]
                        )
                      : _vm._e(),
                    !_vm.isHistoryData
                      ? _c("div", { staticClass: "survivalList" }, [
                          _c(
                            "div",
                            { staticClass: "survivalList__item" },
                            [
                              _c("div", { staticClass: "top" }, [
                                _vm._v("昨日收益")
                              ]),
                              _vm.getValueStatus(_vm.yesterdaySEarnings) == "1"
                                ? [
                                    _c("div", { staticClass: "bottom green" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.yesterdaySEarnings
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.yesterdaySEarnings) == "2"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.yesterdaySEarnings
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.yesterdaySEarnings) == "4"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v("--")
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.yesterdaySEarnings) == "3"
                                ? [
                                    _c("div", { staticClass: "bottom red" }, [
                                      _vm._v(
                                        " +" +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.yesterdaySEarnings
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "survivalList__item" },
                            [
                              _c("div", { staticClass: "top" }, [
                                _vm._v("持有收益")
                              ]),
                              _vm.getValueStatus(_vm.positionIncome) == "1"
                                ? [
                                    _c("div", { staticClass: "bottom green" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.positionIncome
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.positionIncome) == "2"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.positionIncome
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.positionIncome) == "4"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v("--")
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.positionIncome) == "3"
                                ? [
                                    _c("div", { staticClass: "bottom red" }, [
                                      _vm._v(
                                        "+" +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.positionIncome
                                            )
                                          )
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "survivalList__item" },
                            [
                              _c("div", { staticClass: "top" }, [
                                _vm._v("持有收益率")
                              ]),
                              _vm.getValueStatus(_vm.holdingRateOfReturn) == "1"
                                ? [
                                    _c("div", { staticClass: "bottom green" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.holdingRateOfReturn
                                            )
                                          ) +
                                          "% "
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.holdingRateOfReturn) == "2"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.holdingRateOfReturn
                                          )
                                        ) + "%"
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.holdingRateOfReturn) == "4"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v("--")
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.holdingRateOfReturn) == "3"
                                ? [
                                    _c("div", { staticClass: "bottom red" }, [
                                      _vm._v(
                                        " +" +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.holdingRateOfReturn
                                            )
                                          ) +
                                          "% "
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      : _c("div", { staticClass: "survivalList" }, [
                          _c(
                            "div",
                            {
                              staticClass: "survivalList__item",
                              staticStyle: { width: "50%" }
                            },
                            [
                              _c("div", { staticClass: "top" }, [
                                _vm._v("清仓收益")
                              ]),
                              _vm.getValueStatus(_vm.cumulativeIncome) == "1"
                                ? [
                                    _c("div", { staticClass: "bottom green" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.cumulativeIncome
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.cumulativeIncome) == "2"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.cumulativeIncome
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.cumulativeIncome) == "4"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v("--")
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.cumulativeIncome) == "3"
                                ? [
                                    _c("div", { staticClass: "bottom red" }, [
                                      _vm._v(
                                        "+" +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.cumulativeIncome
                                            )
                                          )
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "survivalList__item",
                              staticStyle: { width: "50%" }
                            },
                            [
                              _c("div", { staticClass: "top" }, [
                                _vm._v("清仓收益率")
                              ]),
                              _vm.getValueStatus(_vm.cumulativeRate) == "1"
                                ? [
                                    _c("div", { staticClass: "bottom green" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.cumulativeRate.toFixed(2)
                                          ) +
                                          "% "
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.cumulativeRate) == "2"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.cumulativeRate
                                          )
                                        ) + "%"
                                      )
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.cumulativeRate) == "4"
                                ? [
                                    _c("div", { staticClass: "bottom" }, [
                                      _vm._v("--")
                                    ])
                                  ]
                                : _vm._e(),
                              _vm.getValueStatus(_vm.cumulativeRate) == "3"
                                ? [
                                    _c("div", { staticClass: "bottom red" }, [
                                      _vm._v(
                                        " +" +
                                          _vm._s(
                                            _vm.cumulativeRate.toFixed(2)
                                          ) +
                                          "% "
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]),
                    _c(
                      "div",
                      { staticClass: "dropMore" },
                      [
                        _c("van-icon", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showDropContent,
                              expression: "!showDropContent"
                            }
                          ],
                          attrs: { name: "arrow-down" },
                          on: {
                            click: function($event) {
                              _vm.showDropContent = true
                            }
                          }
                        }),
                        _c("van-icon", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showDropContent,
                              expression: "showDropContent"
                            }
                          ],
                          attrs: { name: "arrow-up" },
                          on: {
                            click: function($event) {
                              _vm.showDropContent = !_vm.showDropContent
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showDropContent &&
                              !_vm.isMonetaryFund &&
                              !_vm.isHistoryData,
                            expression:
                              "showDropContent && !isMonetaryFund && !isHistoryData"
                          }
                        ],
                        staticClass: "dropMoreDetail"
                      },
                      [
                        _c("div", { staticClass: "dropList width60" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("最新净值")
                          ]),
                          _c("div", { staticClass: "dropList__right" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.dataObj.latestNetWorth) +
                                "(" +
                                _vm._s(
                                  _vm.formatDate(_vm.dataObj.netWorthDate)
                                ) +
                                ") "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "dropList width40" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("持有份额")
                          ]),
                          _vm.getValueStatus(_vm.dataObj.holdShare) == "4"
                            ? _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(" -- ")
                              ])
                            : _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(_vm._s(_vm.dataObj.holdShare))
                              ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "dropList width60" },
                          [
                            _c("div", { staticClass: "dropList__left" }, [
                              _vm._v("日涨幅")
                            ]),
                            _vm.getValueStatus(_vm.dailyIncrease) == "1"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropList__right reduceStyle"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.dailyIncrease) + "% "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.dailyIncrease) == "2"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("0.00%")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.dailyIncrease) == "4"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("--")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.dailyIncrease) == "3"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right addStyle" },
                                    [
                                      _vm._v(
                                        "+" + _vm._s(_vm.dailyIncrease) + "%"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c("div", { staticClass: "dropList width40" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("成本净值")
                          ]),
                          _vm.getValueStatus(_vm.dataObj.netCost) == "2"
                            ? _c("div", { staticClass: "dropList__right" })
                            : _vm._e(),
                          _vm.getValueStatus(_vm.dataObj.netCost) == "4"
                            ? _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(" -- ")
                              ])
                            : _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dataObj.netCost
                                        ? (_vm.dataObj.netCost * 1).toFixed(4)
                                        : ""
                                    ) +
                                    " "
                                )
                              ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "dropList width60" },
                          [
                            _c("div", { staticClass: "dropList__left" }, [
                              _vm._v("浮动盈亏")
                            ]),
                            _vm.getValueStatus(_vm.cumulativeIncome) == "1"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropList__right reduceStyle"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.cumulativeIncome) +
                                          "(" +
                                          _vm._s(
                                            _vm.cumulativeRate.toFixed(2)
                                          ) +
                                          "%) "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cumulativeIncome) == "2"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("0.00")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cumulativeIncome) == "4"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("--")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cumulativeIncome) == "3"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right addStyle" },
                                    [
                                      _vm._v(
                                        "+" +
                                          _vm._s(_vm.cumulativeIncome) +
                                          "(+" +
                                          _vm._s(
                                            _vm.cumulativeRate.toFixed(2)
                                          ) +
                                          "%)"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "dropList width60" },
                          [
                            _c("div", { staticClass: "dropList__left" }, [
                              _vm._v("累计现金分红金额")
                            ]),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "1"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropList__right reduceStyle"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.cashDividendAmount) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "2"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("0.00")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "4"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("--")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "3"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right addStyle" },
                                    [
                                      _vm._v(
                                        "+" + _vm._s(_vm.cashDividendAmount)
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm.monthKnot
                          ? _c(
                              "div",
                              { staticClass: "dropList width60" },
                              [
                                _c("div", { staticClass: "dropList__left" }, [
                                  _vm._v("未兑付收益")
                                ]),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "1"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropList__right reduceStyle"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.unpaidEarnings) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "2"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "dropList__right" },
                                        [_vm._v("0.00")]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "4"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "dropList__right" },
                                        [_vm._v("--")]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "3"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropList__right addStyle"
                                        },
                                        [
                                          _vm._v(
                                            "+" + _vm._s(_vm.unpaidEarnings)
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showDropContent &&
                              !_vm.isMonetaryFund &&
                              _vm.isHistoryData,
                            expression:
                              "showDropContent && !isMonetaryFund && isHistoryData"
                          }
                        ],
                        staticClass: "dropMoreDetail"
                      },
                      [
                        _c("div", { staticClass: "dropList width60" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("清仓净值")
                          ]),
                          _c("div", { staticClass: "dropList__right" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.dataObj.latestNetWorth) +
                                "(" +
                                _vm._s(
                                  _vm.formatDate(_vm.dataObj.netWorthDate)
                                ) +
                                ") "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "dropList width40" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("成本净值")
                          ]),
                          _vm.getValueStatus(_vm.dataObj.netCost) == "2"
                            ? _c("div", { staticClass: "dropList__right" })
                            : _vm._e(),
                          _vm.getValueStatus(_vm.dataObj.netCost) == "4"
                            ? _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(" -- ")
                              ])
                            : _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dataObj.netCost
                                        ? (_vm.dataObj.netCost * 1).toFixed(4)
                                        : ""
                                    ) +
                                    " "
                                )
                              ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "dropList width60" },
                          [
                            _c("div", { staticClass: "dropList__left" }, [
                              _vm._v("累计现金分红金额")
                            ]),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "1"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropList__right reduceStyle"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.cashDividendAmount) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "2"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("0.00")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "4"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("--")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.cashDividendAmount) == "3"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right addStyle" },
                                    [
                                      _vm._v(
                                        "+" + _vm._s(_vm.cashDividendAmount)
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm.monthKnot
                          ? _c(
                              "div",
                              { staticClass: "dropList width60" },
                              [
                                _c("div", { staticClass: "dropList__left" }, [
                                  _vm._v("未兑付收益")
                                ]),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "1"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropList__right reduceStyle"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.unpaidEarnings) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "2"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "dropList__right" },
                                        [_vm._v("0.00")]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "4"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "dropList__right" },
                                        [_vm._v("--")]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "3"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropList__right addStyle"
                                        },
                                        [
                                          _vm._v(
                                            "+" + _vm._s(_vm.unpaidEarnings)
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showDropContent && _vm.isMonetaryFund,
                            expression: "showDropContent && isMonetaryFund"
                          }
                        ],
                        staticClass: "dropMoreDetail"
                      },
                      [
                        _c("div", { staticClass: "dropList width60" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("累计收益")
                          ]),
                          _c("div", { staticClass: "dropList__right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.dataObj.cumulativeIncome
                                    ? _vm.dataObj.cumulativeIncome
                                    : "--"
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "dropList width40" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("持有份额")
                          ]),
                          _vm.getValueStatus(_vm.dataObj.holdShare) == "4"
                            ? _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(" -- ")
                              ])
                            : _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(_vm._s(_vm.dataObj.holdShare))
                              ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "dropList width60" },
                          [
                            _c("div", { staticClass: "dropList__left" }, [
                              _vm._v("万份收益 ")
                            ]),
                            _vm.getValueStatus(_vm.fundIncome) == "1"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right " },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.fundIncome) +
                                          " (" +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.dataObj.fundIncomeDate
                                            )
                                          ) +
                                          ") "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.fundIncome) == "2"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [
                                      _vm._v(
                                        "0.00(" +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.dataObj.fundIncomeDate
                                            )
                                          ) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.fundIncome) == "4"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right" },
                                    [_vm._v("--")]
                                  )
                                ]
                              : _vm._e(),
                            _vm.getValueStatus(_vm.fundIncome) == "3"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "dropList__right " },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.fundIncome) +
                                          "(" +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.dataObj.fundIncomeDate
                                            )
                                          ) +
                                          ")"
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c("div", { staticClass: "dropList width40" }, [
                          _c("div", { staticClass: "dropList__left" }, [
                            _vm._v("成本净值")
                          ]),
                          _vm.getValueStatus(_vm.dataObj.netCost) == "2"
                            ? _c("div", { staticClass: "dropList__right" })
                            : _vm._e(),
                          _vm.getValueStatus(_vm.dataObj.netCost) == "4"
                            ? _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(" -- ")
                              ])
                            : _c("div", { staticClass: "dropList__right" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dataObj.netCost
                                        ? (_vm.dataObj.netCost * 1).toFixed(4)
                                        : ""
                                    ) +
                                    " "
                                )
                              ])
                        ]),
                        _vm.monthKnot
                          ? _c(
                              "div",
                              { staticClass: "dropList width60" },
                              [
                                _c("div", { staticClass: "dropList__left" }, [
                                  _vm._v("未兑付收益")
                                ]),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "1"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropList__right reduceStyle"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.unpaidEarnings) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "2"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "dropList__right" },
                                        [_vm._v("0.00")]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "4"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "dropList__right" },
                                        [_vm._v("--")]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm.getValueStatus(_vm.unpaidEarnings) == "3"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropList__right addStyle"
                                        },
                                        [
                                          _vm._v(
                                            "+" + _vm._s(_vm.unpaidEarnings)
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm.dataObj.inTransitTransactions &&
                  _vm.dataObj.inTransitTransactions.length > 0
                    ? _c(
                        "div",
                        { staticClass: "tradingList" },
                        _vm._l(_vm.dataObj.inTransitTransactions, function(
                          item,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index, staticClass: "tradingItem" },
                            [
                              _c("span", { staticClass: "dotted" }),
                              _c("span", { staticClass: "buyDetail" }, [
                                _vm._v(_vm._s(item))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "fundChart" },
                    [
                      _vm.isMonetaryFund
                        ? _c("fund-chart", {
                            key: _vm.componentKey,
                            attrs: { tabList: _vm.fundTab1 }
                          })
                        : _c("fund-chart", {
                            key: _vm.componentKey,
                            attrs: { tabList: _vm.fundTab }
                          })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "transactionDetail",
                      on: { click: _vm.goTradePage }
                    },
                    [
                      _c("div", { staticClass: "transactionDetail__left" }, [
                        _vm._v("交易明细")
                      ]),
                      _c(
                        "div",
                        { staticClass: "transactionDetail__right" },
                        [
                          !!_vm.dataObj.quantityToBeConfirmed
                            ? _c("div", { staticClass: "sureTransaction" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.dataObj.quantityToBeConfirmed) +
                                    "笔待完成 "
                                )
                              ])
                            : _vm._e(),
                          _c("van-icon", {
                            staticClass: "customIcon",
                            attrs: { name: "arrow" }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  !_vm.isMonetaryFund
                    ? _c(
                        "div",
                        { staticClass: "investmentBox" },
                        [_c("invesment")],
                        1
                      )
                    : _vm._e(),
                  _vm.dataObj.cashDividendVoList &&
                  _vm.dataObj.cashDividendVoList.length
                    ? _c(
                        "div",
                        {
                          staticClass: "transactionDetail",
                          on: { click: _vm.dividendsAmountClick }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "transactionDetail__left flex" },
                            [_vm._v("现金分红记录")]
                          ),
                          _c(
                            "div",
                            { staticClass: "transactionDetail__right" },
                            [
                              _vm.dataObj.cashDividendAmount
                                ? _c(
                                    "div",
                                    { staticClass: "normalStyle totalAmount" },
                                    [
                                      _vm._v(
                                        "总金额(元)：" +
                                          _vm._s(
                                            _vm._f("formatMoney")(
                                              _vm.dataObj.cashDividendAmount
                                            )
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("van-icon", {
                                staticClass: "customIcon devide-arrow",
                                attrs: { name: "arrow" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.dataObj.dividendMethod
                    ? _c("div", { staticClass: "transactionDetail" }, [
                        _c(
                          "div",
                          { staticClass: "transactionDetail__left flex" },
                          [
                            _vm._v("分红方式 "),
                            _c("img", {
                              staticClass: "audit",
                              attrs: {
                                src: require("@/assets/images/icons/questionMark.png"),
                                alt: ""
                              },
                              on: { click: _vm.divideDes }
                            })
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "transactionDetail__right",
                            on: { click: _vm.dividendClick }
                          },
                          [
                            _vm.dataObj.dividendMethodReview
                              ? _c(
                                  "div",
                                  { staticClass: "normalStyle normal-width" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dividendMethodArr[
                                          _vm.dividendMethod
                                        ]
                                      ) + "(变更中)"
                                    )
                                  ]
                                )
                              : _c("div", { staticClass: "normalStyle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dividendMethodArr[_vm.dividendMethod]
                                    )
                                  )
                                ]),
                            _vm.dataObj.dividendMethodUpdate
                              ? _c("van-icon", {
                                  staticClass: "customIcon",
                                  attrs: { name: "arrow" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "transactionDetail" }, [
                    _c("div", { staticClass: "transactionDetail__left" }, [
                      _vm._v("管理人")
                    ]),
                    _c("div", { staticClass: "transactionDetail__right" }, [
                      _c("div", { staticClass: "normalStyle" }, [
                        _vm._v(_vm._s(_vm.managerName))
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "riskTip" }, [
                    _vm._v(
                      " 风险提示:投资有风险。基金的过往业绩及其净值高低并不预示其未来表现。 基金管理人管理的其他基金的业绩并不构成基金业绩表现的保证。 相关数据仅供参考，不构成投资建议。投资人请详阅基金合同和基金招募说明书，并自行承担投资风险。 "
                    )
                  ]),
                  typeof _vm.isFinished == "boolean" && _vm.isFinished
                    ? _c(
                        "div",
                        {
                          staticClass: "fixedBtn",
                          class: { hairPhone: _vm.isIphone }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "fixedBtn__list normalBtn",
                              class: _vm.canRedeem ? "" : "grey",
                              on: { click: _vm.handleSold }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.canRedeem ? "卖出" : "暂停赎回") +
                                  " "
                              )
                            ]
                          ),
                          _vm.isSupportFixedInt == "1" &&
                          _vm.userType == "1" &&
                          _vm.certificateType == "0"
                            ? _c(
                                "div",
                                {
                                  staticClass: "fixedBtn__list normalBtn",
                                  class: _vm.canRedeem ? "fixedInvest" : "",
                                  on: { click: _vm.goToFixedInves }
                                },
                                [_vm._v(" 定投 ")]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "fixedBtn__list primaryBtn",
                              class: _vm.canBooking ? "" : "grey",
                              on: { click: _vm.handleBuy }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.canBooking ? "买入" : "暂停申购") +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _c("div", [_c("divide-popup", { ref: "divideRef" })], 1)
        ],
        1
      ),
      _c("tips", { ref: "tipComponent", attrs: { content: _vm.tipsContent } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }